import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/home/Home.vue'
import Meeting from '../views/meeting/index.vue'
import MeetingRoom from '../views/meeting/meetingRome.vue'
import Card from '../views/card/index.vue'
import Invite from '../views/invite/index.vue'
import live from '../views/live/index.vue'
import city from "../views/city/index.vue"
import Drama from '../views/drama/index.vue'
import i18n from '@/language'
import News from '../views/news/index.vue'
import AiRecord from '../views/aiRecord/index.vue'
import AiShare from '../views/aiShare/index.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/m/:type/:id/:i18n',
    name: 'm',
    component: Home,
  },
  // {
  //   path: '/dao',
  //   name: 'dao',
  //   component: () => import("@/views/dao/index.vue"),
  // },
  {
    path: '/meeting',
    name: 'Meeting',
    component: Meeting,
  },
  {
    path: '/meeting/room',
    name: 'MeetingRoom',
    component: MeetingRoom,
  },
  {
    path: '/live',
    name: 'Live',
    component: live,
  },
  {
    path: '/drama',
    name: 'Drama',
    component: Drama,
  },
  {
    path: '/drama/official/detail/:id',
    name: 'DramaDetail',
    component: Drama,
  },
  {
    path: '/invite',
    name: 'Invite',
    component: Invite,
  },
  {
    path: '/news',
    name: 'News',
    component: News,
  },
  {
    path: '/ai-record',
    name: 'AiRecord',
    component: AiRecord,
  },
  {
    path: '/ai-share',
    name: 'AiShare',
    component: AiShare,
  },
  {
    path: '/city',
    name: 'City',
    component: city,
  },
  {
    path: '/card/:type',
    name: 'Card',
    component: Card,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  console.log(to, "tototo")
  if (to.query?.i18n) {
    i18n.global.locale = to.query.i18n as any
  }
  if (to.path.startsWith('/m/')) {
    const type = to.params?.type;
    if (type) {
      switch (type) {
        case '1000':
          if (to.path !== '/meeting') {
            next({
              name: 'Meeting',
              query: {
                ...to.params,
                channelCode: "Envo",
                // ...(Object.prototype.hasOwnProperty.call(to.query, 'theme') ? { theme: 'light' } : {}),
              },
            })
          } else {
            next()
          }
          break
        case '1001':
          if (to.path !== '/live') {
            next({
              name: 'Live',
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1002':
          if (to.path !== '/invite') {
            next({
              name: 'Invite',
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1003':
          if (to.path !== '/card/user') {
            next({
              name: 'Card',
              params: {
                type: 'user',
              },
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1004':
          if (to.path !== '/city') {
            next({
              name: 'City',
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1006':
          if (to.path !== '/drama') {
            next({
              name: 'Drama',
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1005':
          if (to.path !== '/news') {
            next({
              name: 'News',
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1007':
          if (to.path !== '/ai-record') {
            next({
              name: 'AiRecord',
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1020':
          next({
            name: 'AiShare',
            query: { ...to.query, ...to.params, channelCode: 'Envo' },
          })
          break
        case '0':
          if (to.path !== '/home') {
            next({
              name: 'Home',
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        case '1':
          if (to.path !== '/card/group') {
            next({
              name: 'Card',
              params: {
                type: 'group',
              },
              query: { ...to.params, channelCode: "Envo" },
            })
          } else {
            next()
          }
          break
        default:
          next()
      }
    } else {
      next()
    }

    return
  }

  if (to.name === 'MeetingRoom') {
    next()
    return
  }

  // const type = to.params?.type

  const type = to.params?.type || to.query?.type

  if (type) {
    switch (type) {
      case '1000':
        if (to.path !== '/meeting') {
          next({
            name: 'Meeting',
            query: {
              ...to.query,
              // ...(Object.prototype.hasOwnProperty.call(to.query, 'theme') ? { theme: 'light' } : {}),
            },
          })
        } else {
          next()
        }
        break
      case '1001':
        if (to.path !== '/live') {
          next({
            name: 'Live',
            query: { ...to.query },
          })
        } else {
          next()
        }
        break
      case '1002':
        if (to.path !== '/invite') {
          next({
            name: 'Invite',
            query: { ...to.query },
          })
        } else {
          next()
        }
        break
      case '1003':
        if (to.path !== '/card/user') {
          next({
            name: 'Card',
            params: {
              type: 'user',
            },
            query: { ...to.query },
          })
        } else {
          next()
        }
        break
      case '1004':
        if (to.path !== '/city') {
          next({
            name: 'City',
            query: { ...to.query },
          })
        } else {
          next()
        }
        break
      case '1006':
        if (to.path !== '/drama') {
          next({
            name: 'Drama',
            query: { ...to.query },
          })
        } else {
          next()
        }
        break
      case '1005':
        if (to.path !== '/news') {
          next({
            name: 'News',
            query: { ...to.query },
          })
        } else {
          next()
        }
        break;
      case '1007':
        if (to.path !== '/ai-record') {
          next({
            name: 'AiRecord',
            query: { ...to.query },
          })
        } else {
          next()
        }
        break;
      case '1020':
        if (to.name !== 'AiShare') {
          next({ name: 'AiShare', query: { ...to.query } })
        } else {
          next()
        }
        break
      case '0':
        if (to.path !== '/home') {
          next({
            name: 'Home',
            query: { ...to.query, channelCode: "Envo" },
          })
        } else {
          next()
        }
        break
      case '1':
        if (to.path !== '/card/group') {
          next({
            name: 'Card',
            params: {
              type: 'group',
            },
            query: { ...to.query },
          })
        } else {
          next()
        }
        break
      default:
        next()
    }
  } else {
    console.log('No type found, continue with next')
    next()
  }
})

export default router
